import { Form, message, Modal, Upload } from "antd";
import React, { useState } from "react";
import { ReactSVG } from "react-svg";
import { getBase64Promise } from "../../utils/image";
import "./Image.scss";

const ImageUploader = ({
  name,
  image,
  setImage,
  isRequired,
  isDisabled,
  acceptType,
  setPreviewImage,
  previewImage,
  handleRemoveLogo,
}) => {
  const [previewVisible, setPreviewVisible] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  // const handleFailed = (file) =>
  //   message.error(`${file.name} file upload failed.`);
  const handleRemoved = file => message.success(`${file.name} file removed successful`);
  const handleUploaded = file => message.success(`${file.name} file uploaded successful.`);
  const disable = isDisabled || false;
  const handleChangeFile = async file => {
    if (file.status === "uploading") {
      const previewFile = await getBase64Promise(file.originFileObj);
      const result = previewFile.split("base64,");
      const previewSrc = `data:image/jpeg;base64,${result[1]}`;
      let newFile = {};
      newFile = {
        ...file,
        name: file.name,
        type: file.type,
        url: previewSrc,
      };
      if (newFile) {
        delete file.preview;
        setImage(file.originFileObj);
        setPreviewImage(previewSrc);
        handleRemoveLogo();
      }
    }

    if (file.status !== "uploading") {
      handleUploaded(file);
    }

    if (file.status === "removed") {
      setImage({});
      handleRemoved(file);
    }

    // if (file.status === "error") {
    //   handleFailed(file);
    // }
  };
  const uploadProps = {
    name,
    fileList: [image],
    accept: acceptType || "image/png, image/jpeg, image/jpg",
    async onChange({ file }) {
      handleChangeFile(file);
      handleRemoveLogo(false);
    },
    showUploadList: false,
    onPreview(file) {
      handlePreview(file);
    },
  };

  const handleCancel = () => setPreviewVisible(false);
  const handleRemove = () => {
    setPreviewImage("");
    handleRemoveLogo(true);
  };

  const handlePreview = async file => {
    setPreviewVisible(true);
    setPreviewImage(file.url);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf("/") + 1));
  };

  return (
    <div className="image-uploader-container">
      <Form.Item
        name={name}
        className="documents"
        rules={[
          { required: isRequired, message: "is required" },
          {
            validator: (_, value) => {
              if (!isRequired || !value || value.fileList.length > 0) {
                return Promise.resolve();
              }
              return Promise.reject(new Error("is required"));
            },
          },
        ]}>
        {previewImage && (
          <div className="preview-section">
            <div className="image">
              <img alt="upload-logo" src={previewImage} />
            </div>
            <a onClick={handleRemove}>
              Remove Logo <ReactSVG src="/icons/delete-circle.svg" />
            </a>
          </div>
        )}
        <Upload.Dragger {...uploadProps} disabled={disable}>
          <div className="upload-text-section">
            <p className="ant-upload-text">Drag and drop to upload or</p>
            <div className="ant-upload-hint">
              Browse
              <ReactSVG src="/icons/browse.svg" />
            </div>
          </div>
        </Upload.Dragger>
      </Form.Item>
      <Modal open={previewVisible} title={previewTitle} footer={null} onCancel={handleCancel}>
        <img alt="logo" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  );
};

export default ImageUploader;
